import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Typography, Checkbox, Box } from "@mui/material";
import BannerSettingsOption from "./BannerSettingsOption";
import { useTranslation } from "react-i18next";

const totalBannerImages = 3;

const useStyles = makeStyles(() => ({
  image: {
    width: "100%"
  },

  uploadButton: {
    cursor: "pointer",
    minWidth: "100%"
  }
}));
const bannerImageMaxSize = { w: 2880, h: 600 };

function BannerSettings(props) {
  const { bannerImages, noBanner, onBannerImageReset } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  let currentBannerImages = [
    ...new Array(totalBannerImages)
  ].map((bannerImage, index) =>
    bannerImages && bannerImages[index] ? bannerImages[index] : { imgPath: "" }
  );

  let onBannerImagesChange = (event, index) => {
    if (event.target.files) {
      let status = "active";
      let file = new Image(),
        rawFile = event.target.files[0];
      file.src = URL.createObjectURL(rawFile);
      file.onload = function() {
        if (
          file.width !== bannerImageMaxSize.w ||
          file.height !== bannerImageMaxSize.h
        ) {
          alert(t("settings.bannerSettings.checkSizeText"));
        } else {
          props.onBannerImagesChange(rawFile, index, status);
        }
      };
    }
  };

  let onBannerImageDelete = (event, index) => {
    props.deleteBannerImage(index);
  };

  return (
    <div className={classes.root}>
      <Box display="flex" alignItems="center" ml={-1.5} pt={3} pb={2}>
        <Checkbox
          checked={noBanner}
          onChange={e => props.handleNoBannerOptionChange(!noBanner)}
          value={noBanner}
          inputProps={{
            "aria-label": "primary checkbox"
          }}
        />
        <Typography variant="subtitle1" color="textPrimary">
          {t("settings.bannerSettings.noBanner")}
        </Typography>
      </Box>
      {currentBannerImages.map((bannerImage, index) => (
        <BannerSettingsOption
          key={index}
          onBannerImageUpload={onBannerImagesChange}
          onBannerImageReset={onBannerImageReset}
          onBannerImageDelete={onBannerImageDelete}
          bannerImage={bannerImage}
          index={index}
        />
      ))}
    </div>
  );
}

export default BannerSettings;
